import {
  NAME_MAX_LENGTH,
  NAME_MIN_LENGTH,
  NAME_VALIDATION_MESSAGES,
  SHORT_DESCRIPTION_MAX_LENGTH,
  SHORT_DESCRIPTION_VALIDATION_MESSAGES,
} from '@azymmetric/shared/validation/validation.constants';
import { zCoercedOptional } from '@utils/zodv4.util';
import { z } from 'zod/v4';

export const useSchema = z.object({
  description: zCoercedOptional(
    z.string().max(SHORT_DESCRIPTION_MAX_LENGTH, { message: SHORT_DESCRIPTION_VALIDATION_MESSAGES.max }).optional(),
  ),
  name: z
    .string()
    .min(NAME_MIN_LENGTH, { message: NAME_VALIDATION_MESSAGES.min })
    .max(NAME_MAX_LENGTH, { message: NAME_VALIDATION_MESSAGES.max }),
});

export type UseSchema = z.infer<typeof useSchema>;
